<template>
    <v-app>
        <header-component>
            <template v-slot:account_menu>
                <v-menu offset-y transition="slide-y-transition">
                    <template v-slot:activator="{ on, attrs }">
                        <v-toolbar-title style="color:white" v-bind="attrs" v-on="on" class="userName" >
                        {{ user.name }}▼
                        </v-toolbar-title>
                    </template>
                    <v-list>
                        <v-list-item
                        v-for="(item, index) in items"
                        :key="index"
                        link
                        :href="item.href"
                        >
                            <v-list-item-title>
                                <v-icon> {{ item.icon }}</v-icon>
                                {{ item.title }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </header-component>
        
        <template>
            <v-app-bar color="#E7F9F7" flat height="60" app style="z-index:99;">
                <v-toolbar-title>
                    <h2>
                        <slot name="title"></slot>
                    </h2>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="canDraftSave" class="ms-2 white--text" color="blue" @click="save">下書き保存</v-btn>
                <v-btn v-if="canDraftSave" class="ms-2 white--text" color="blue-grey" @click="confirmDeleteDialog = true">破棄</v-btn>
            </v-app-bar>

            <v-navigation-drawer :permanent="true" :width=275 :app="true" color="#E7F9F7">
                <v-subheader style="height:60px;">
                    <slot name="subheader"></slot>
                </v-subheader>
                
                <!-- メニューをslotで読み込む -->
                <slot name="step_menu"></slot>
                <slot name="optional"></slot>
            </v-navigation-drawer>
        </template>

        <!-- アプリケーションのコンポーネントに基づいてコンテンツのサイズを決定 -->
        <v-main ref="child" class="my-1" :app="true">
            <slot name="contents"></slot>
            <!-- メッセージ -->
            <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
            <v-overlay :value="sending" z-index="10000">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
                <span class="loading">処理中です...</span>
            </v-overlay>

            <!-- アプリケーションに適切なgutterを提供します -->
            <!--<v-container fluid> -->
            <!-- vue-routerを使用している場合 -->
            <!--</v-container>-->
            <!-- 削除確認ダイアログ -->
            <simple-dialog-component v-if="confirmDeleteDialog" :dialog.sync="confirmDeleteDialog" @clickOk="deleteAgreement" okBtn="破棄" cancelbtn="キャンセル">
                <div>破棄してよろしいですか？</div>
            </simple-dialog-component>
        </v-main>

        <footer-component>
        </footer-component>
    </v-app>
</template>

<script>
  import {setTimeoutCheckLogin} from '../../common/loginUtil.js';
  export default {
    props: {
        user: Object,
        canDraftSave: {
            type: Boolean(),
            default: true,
            required: false,
        },
    },
    data: () => ({
        items: [
            { title: 'ダッシュボード', href: '/documents/dashboard', 'icon': 'mdi-home' },
            { title: '管理', href: '/documents/notifications', 'icon': 'mdi-cog' },
            { title: 'ログアウト', href: '/documents/logout', 'icon': 'mdi-logout' },
        ],
        confirmDeleteDialog: false,
        draftSaving: false,
        sending: false,
        message: {
            success: false,
            text: '',
        },
    }),
    computed: {
        isMessage: {
            get() {
                return this.message.text != '';
            },
            set(value) {
                if (!value) {
                    this.message.text = '';
                }
            }
        },
    },
    methods: {
        // 下書き保存
        save: async function () {
            // this.draftSaving = true;
            this.sending = true;
            try {
                let result = await this.$refs.child.$children[0].save(1);
                if (result) {
                    this.message.success = true;
                    this.message.text = "保存しました。";
                }
            }
            finally {
                this.sending = false;
            }
        },
        // 破棄
        deleteAgreement: async function() {
            this.sending = true;
            try {
                var self = this;
                await window.axios
                    .delete('delete')
                    .then(function (response) {
                        if (response.data.success) {
                            window.location = "/documents/dashboard";
                        } 
                        else {
                            if (response.data.message) {
                                self.message.text = response.data.message;
                            } else {
                                self.message.text = "削除処理に失敗しました";
                            }
                            self.message.success = false;
                        }
                    })
                    .catch(function (response) {
                        console.log(response);
                        self.message.text = "削除処理に失敗しました";
                        self.message.success = false;
                    }
                );
            }
            finally {
                this.sending = false;
            }
        },
    },
  };
</script>

<style>
    .userName {
      max-width: 70%;
    }
</style>
